import { InjectionToken } from '@angular/core';
import { TagManagerBase } from './tag-manager-base';

export const TAG_MANAGER = new InjectionToken<TagManagerBase[]>(
  'tag-managers-list'
);
